export default "__VITE_ASSET__Ddv4BnVM__"